import { render, staticRenderFns } from "./FailureStatistics.vue?vue&type=template&id=09f98a32&scoped=true"
import script from "./FailureStatistics.vue?vue&type=script&lang=js"
export * from "./FailureStatistics.vue?vue&type=script&lang=js"
import style0 from "./FailureStatistics.vue?vue&type=style&index=0&id=09f98a32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f98a32",
  null
  
)

export default component.exports